// Interpolation helpers shared across the strip's modules. One sampler
// replaces the three near-identical piecewise interpolators the strip
// used to carry (active line, fan series, loss-of-control bounds).

export type TimeValuePoint = { time: number; value: number }

export const lerpNumber = (from: number, to: number, t: number) =>
  from + (to - from) * t

// Normalizes {date,value} points (Date or ISO string) for sampling.
export const toTimeValuePoints = (
  series: ReadonlyArray<{ date: Date | string; value: number }>,
): TimeValuePoint[] =>
  series.map(point => ({
    time: new Date(point.date).getTime(),
    value: point.value,
  }))

// Piecewise-linear value at time t, clamped to the end values.
export const sampleSeriesAt = (series: TimeValuePoint[], t: number): number => {
  if (series.length === 0) return 1
  if (t <= series[0].time) return series[0].value
  if (t >= series[series.length - 1].time) return series[series.length - 1].value
  return valueBetweenPoints(series, t)
}

const valueBetweenPoints = (series: TimeValuePoint[], t: number): number => {
  for (let i = 0; i < series.length - 1; i++) {
    const a = series[i]
    const b = series[i + 1]
    if (t < a.time || t > b.time) continue
    const ratio = b.time === a.time ? 0 : (t - a.time) / (b.time - a.time)
    return a.value + ratio * (b.value - a.value)
  }
  return series[series.length - 1].value
}
